import React from 'react';
import {
  Table as MuiTable,
  TableContainer as MuiTableContainer,
  TableBody,
} from '@mui/material';
import { TableContainerProps, TableProps } from '../../types';

export interface EnhancedTableContainerProps {
  children: React.ReactNode;
  containerProps?: TableContainerProps;
  tableProps?: TableProps;
  stickyHeader?: boolean;
  dense?: boolean;
  ariaLabel?: string;
  afterTable?: React.ReactNode; // Content rendered inside the container after the table (e.g., sticky footer)
}

export function EnhancedTableContainer({
  children,
  containerProps,
  tableProps,
  stickyHeader = false,
  dense = false,
  ariaLabel = 'enhanced table',
  afterTable,
}: EnhancedTableContainerProps) {
  return (
    <MuiTableContainer {...containerProps}>
      <MuiTable
        stickyHeader={stickyHeader}
        size={dense ? 'small' : 'medium'}
        aria-label={ariaLabel}
        sx={{
          width: '100%',
          '& .MuiTableFooter-root': {
            width: '100%',
          },
          '& .MuiTableFooter-root .MuiTableRow-root': {
            width: '100%',
          },
          '& .MuiTableFooter-root .MuiTableCell-root': {
            width: '100%',
            maxWidth: 'none',
          },
          ...tableProps?.sx,
        }}
        {...tableProps}
      >
        {children}
      </MuiTable>
      {afterTable}
    </MuiTableContainer>
  );
}

export interface EnhancedTableBodyProps {
  children: React.ReactNode;
}

export function EnhancedTableBody({ children }: EnhancedTableBodyProps) {
  return <TableBody>{children}</TableBody>;
}
